module.exports = __webpack_public_path__ + "img/icon_item4.196684f7.png";